import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchServices = () => api.get("/services").then((r) => r.data);
export const fetchAffirmations = () =>
  api.get("/affirmations").then((r) => r.data);
export const fetchDailyAffirmation = () =>
  api.get("/affirmations/daily").then((r) => r.data);
export const generateAffirmations = (payload) =>
  api.post("/affirmations/generate", payload).then((r) => r.data);
export const fetchAvailability = (date) =>
  api.get(`/bookings/availability`, { params: { date } }).then((r) => r.data);
export const createBooking = (payload) =>
  api.post("/bookings", payload).then((r) => r.data);
